export default {"src":"/_next/static/media/arrow_down.0e4491cf.svg","height":16,"width":16};